import clsx from 'clsx'

import { ModuleIcon } from '@/shared/ui/ModuleIcon'

export function StoreStatusPanel({
  icon = 'shop',
  badge,
  title,
  description,
  footer,
  className
}) {
  return (
    <section
      className={clsx(
        'mb-6 overflow-hidden rounded-2xl border border-brand/15 bg-gradient-to-b from-brand-light/80 to-white shadow-sm',
        className
      )}
      aria-live="polite"
    >
      <div className="flex flex-col items-center px-6 py-8 text-center sm:px-10 sm:py-10">
        {badge ? (
          <span className="mb-4 inline-flex items-center gap-1.5 rounded-full bg-white px-3 py-1 text-2xs font-bold uppercase tracking-wide text-brand shadow-sm">
            {badge}
          </span>
        ) : null}

        <span className="mb-5 inline-flex size-16 items-center justify-center rounded-2xl bg-white shadow-sm ring-1 ring-brand/10">
          <ModuleIcon name={icon} size={40} className="text-brand" />
        </span>

        <div className="flex w-full max-w-md flex-col items-center gap-3">
          {title}
          {description ? (
            <p className="m-0 text-sm font-semibold leading-relaxed text-gray-700">
              {description}
            </p>
          ) : null}
          {footer}
        </div>
      </div>
    </section>
  )
}
